<template>
  <section class="">
    <Events />
  </section>
</template>

<script>
import Events from "./Events.vue";
//import EventsHelp from "./EventsHelp.vue";

export default {
  name: "EventsPage",
  components: {
    Events,
    //EventsHelp,
  },
  data() {
    return { eventId: null };
  },
  methods: {
    async eventSelected(eventId) {
      this.eventId = eventId;
    },
  },
};
</script>
